class UpdatePasswordController {
    static $inject = ["stToast"];

    constructor(stToast) {
        this.toast = stToast;
    }

    $onInit() {
    }
}

angular
    .module("app")
    .component("updatePassword", { // update-password
        templateUrl: "src/app/account/updatePassword/updatePassword.html",
        controller: UpdatePasswordController
    });
